module.exports = __webpack_public_path__ + "img/hybrid.f2ddbc02.png";